<template>
	<v-card class="banner" color="contained">
		<div class="rotate-container">
			<div v-if="compProps.headline" class="rotate">
				<div class="d-flex justify-center align-center" style="height: 100%">
					<img :src="compProps.logo" style="height: 80px; width: auto; margin-right: 25px" />
					<h2>KT Voicebot {{ compProps.headline }}</h2>
				</div>
				<img
					v-for="(logo, index) in logos"
					:key="index"
					:src="logo.src"
					:alt="logo.alt"
					class="banner-logo"
					:style="{ height: logo.height }"
				/>
			</div>
			<div v-else class="rotate">
				<img
					v-for="(logo, index) in logos"
					:key="index"
					:src="logo.src"
					:alt="logo.alt"
					class="banner-logo"
					:style="{ height: logo.height }"
				/>
			</div>
		</div>
	</v-card>
</template>

<script setup lang="ts">
import { ref } from "vue";

const compProps = defineProps({
	headline: String,
	logo: String,
});

const logos = ref([
	{
		src: "https://assets.livereader.com/asset/YSvQcUkqj96bnFer.png",
		alt: "Alternis_Logo",
		height: "90%",
	},
]);
</script>

<style scoped lang="scss">
.banner {
	width: 100vw;
	height: 100px;
	overflow: hidden;
}

.rotate-container {
	display: flex;
	width: 100%;
}

.rotate {
	height: 100px;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-evenly;
}

.banner-logo {
	width: auto;
	flex-shrink: 0;
}
</style>
